import React from 'react';
import AdGuard from './AdGuard';

const HowItWorks = () => {
  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <h1>How It Works</h1>
      <AdGuard adSlot="" />

      <p>
        PDF Blink is built around a simple idea: leverage powerful client-side libraries to let
        users perform rich PDF tasks inside their browser, without requiring an upload to a server.
        This approach improves privacy, reduces latency, and simplifies deployment.
      </p>

      <h2>Client-side processing</h2>
      <p>
        When you upload a PDF or file, JavaScript reads the file into memory and uses libraries
        like <code>pdf-lib</code> and <code>xlsx</code> to parse and manipulate the document. The
        edited result is generated and offered as a downloadable file. This means your original
        file stays on your device unless you explicitly choose to share the output.
      </p>

      <h2>Why client-side?</h2>
      <p>
        Client-side processing offers several benefits: no server-storage costs, stronger privacy
        boundaries, and faster feedback for the user. For large file uploads, server-based
        solutions often require more bandwidth and can increase latency; client-side avoids these
        issues for many typical use cases.
      </p>

      <h2>Modular components</h2>
      <p>
        Each tool in the app is implemented as a small React component. That modular design keeps
        the UI responsive and makes it easy to maintain or add new features. For example, the
        watermark tool simply loads a PDF, draws text on each page, and saves the result — all in a
        few lines of code using the library API.
      </p>

      <h2>Security considerations</h2>
      <p>
        Files are processed locally in memory. The app does include analytics and advertising
        placeholders (you'll see optional Google tags in the HTML). We recommend reviewing the
        privacy policy and only processing documents you are comfortable handling in a browser.
      </p>

      <h2>Export and compatibility</h2>
      <p>
        Output files are standard PDF documents. They can be opened with common readers or printed
        directly. For bulk workflows, you can download and manage outputs locally, or integrate
        the components into your own applications.
      </p>

      <h2>Extending PDF Blink</h2>
      <p>
        Developers can clone the repository, import the components they need, and adapt the UI.
        Because the app uses standard libraries, it's straightforward to add server integration
        later (for example, to support background processing or cloud storage) if required.
      </p>
    </div>
  );
};

export default HowItWorks;
